<div class="flex flex-column">
  @if (showClose) {
    <button class="close" (click)="onCancel()">
      <i class="fa-light fa-xmark"></i>
    </button>
  }

  @if (!savingBagItems) {
    <h3 class="mb-2">
      {{ 'MY.COLLECTIONS.TITLE' | translate }}
      @if (feedbackAfterSaving) {
        <span>
          <i class="fa-solid fa-check mr-1"></i> {{feedbackAfterSaving}}
        </span>
      }
    </h3>
    <div class="collections-container mb-2">
      @for (favoriteCollection of favoriteCollections; track favoriteCollection) {
        <checkbox
          (checkedChange)="toggleFavoriteCollection(favoriteCollection)"
          [checked]="favoriteCollection.CurrentFavoriteUuid !== null && favoriteCollection.CurrentFavoriteUuid !== undefined" [label]="favoriteCollection.Name"
          class="m-2">
        </checkbox>
      }
    </div>
    <span class="text-cta pointer ml-4 mb-1" (click)="showNameInput = !showNameInput">
      + {{ 'MY.COLLECTIONS.CREATE' | translate }}
    </span>
    @if (showNameInput) {
      <div class="favorite-collection-name">
        <input type="text" [(ngModel)]="favoriteCollectionName" maxlength="20"
          placeholder="{{ 'MY.COLLECTIONS.NAME' | translate }}" class="form-control mr-2" (keydown.enter)="toggleFavoriteCollection(null);" />
          <button (click)="toggleFavoriteCollection(null); " class="btn btn-primary btn-xs mb-2">
            {{ 'CREATE' | translate }}
          </button>
        </div>
      }
      <ng-content></ng-content>
    }

    @if (savingBagItems) {
      <h4 class="mb-4">{{ 'MY.COLLECTIONS.SAVE.FRAMES' | translate }}</h4>
      @if (!bagItemsWereSaved) {
        <div class="favorite-collection-name">
          <input type="text" [(ngModel)]="favoriteCollectionName" maxlength="30"
            placeholder="favorite collection name" class="form-control" />
            <div class="buttons">
              <button (click)="saveBagItemsToFavoriteCollection(); " class="btn btn-primary round mr-2">
                {{ 'CUSTOMIZER.COMPONENTS.ADDTOINSPIRATION.ADD' | translate }}
              </button>
              <button (click)="onCancel()" class="btn btn-secondary round">
                {{ 'COMMON.CANCEL' | translate }}
              </button>
            </div>
          </div>
        }
        @if (bagItemsWereSaved && favoriteCollection) {
          <div class="favorite-collection-name mb-3">
            <p class="pb-3" [innerHTML]="('MY.COLLECTIONS.BAG.ITEMS.SAVED' | translate: {favoriteCollectionName: favoriteCollection.Name})"></p>
            <div class="buttons text-center">
              <button class="btn btn-primary mr-2" (click)="gotoFavoriteCollection(favoriteCollection)">
              {{ 'COMMON.GOTO' | translate }} '{{favoriteCollection.Name}}'</button>
              <br>
                <br>
                  <button (click)="onCancel()" class="btn btn-secondary">
                    {{ 'COMMON.CLOSE' | translate }}
                  </button>
                </div>
              </div>
            }
          }

        </div>